export default __webpack_public_path__ + "icon_map_pin_checked.db76b05857be46b7246f966e6d8ebc64.svg";